import Card from "./CardClass";
export default abstract class AttributeCard extends Card {}
